//https://alligator.io/react/usereducer/
//https://hswolff.com/blog/how-to-usecontext-with-usereducer/
import React from "react";
export var EloginStatus;
(function (EloginStatus) {
    EloginStatus[EloginStatus["ToCheck"] = 0] = "ToCheck";
    EloginStatus[EloginStatus["Public"] = 1] = "Public";
    EloginStatus[EloginStatus["Logged"] = 2] = "Logged";
})(EloginStatus || (EloginStatus = {}));
export const AppState = {
    instance: 1,
    lang: 'cs',
    loginState: EloginStatus.ToCheck,
    user: {}
};
export const AppConfig = {
    version: '1.6.20',
    APIUrl: '/api/',
    filesPrefix: '/uploads/',
    titleSufix: ' - Elektronické aukce MORAVOLEN',
    companyName: 'MORAVOLEN HOLDING a.s.',
    address: 'Krátká 2863/2<br />787 01 Šumperk',
    branding: "draspomorava"
};
export const rootReducer = (state, action) => {
    switch (action.type) {
        case 'appReload': return Object.assign(Object.assign({}, state), { instance: state.instance + 1 });
        case 'authCheckLogged': return Object.assign(Object.assign({}, state), { user: action.payload, loginState: EloginStatus.Logged });
        case 'authCheckPublic': return Object.assign(Object.assign({}, state), { loginState: EloginStatus.Public });
        case 'signOut': return Object.assign(Object.assign({}, state), { user: {}, loginState: EloginStatus.Public });
        default: return state;
    }
};
export const AppStateContext = React.createContext(null);
